import * as classnames from 'classnames';
import * as React from 'react';

import Dropzone from 'react-dropzone';

import { FormattedMessage } from 'react-intl';
import { change, WrappedFieldProps } from 'redux-form';

import { Button } from 'components/Button';
import { InputFileImage } from 'components/Input/InputFile/InputFile';
import { MAX_IMAGE_FILE_SIZE_IN_MB } from 'constants/image';

import './InputFileCard.scss';

export interface InputFileCardProps {
  className?: string;
  imageSrc: string;
  label: string;
}

interface InputFileCardState {
  selectedImageFile?: InputFileImage;
}

export class InputFileCard extends React.Component<InputFileCardProps & WrappedFieldProps, InputFileCardState> {
  constructor(props: InputFileCardProps & WrappedFieldProps) {
    super(props);

    this.state = { selectedImageFile: undefined };
    this.onFileSelected = this.onFileSelected.bind(this);
  }

  componentWillMount() {
    const { input } = this.props;
    if (input.value) {
      this.setState({ selectedImageFile: input.value });
    }
  }

  componentWillReceiveProps(nextProps: InputFileCardProps & WrappedFieldProps) {
    if (nextProps.input.value && this.props.input.value !== nextProps.input.value) {
      this.setState({ selectedImageFile: nextProps.input.value });
    }
  }

  render() {
    const { className, input } = this.props;
    return (
      <Dropzone
        className={classnames('input-file-card__container', className)}
        name={input.name}
        accept="image/*"
        multiple={false}
        onDrop={this.onFileSelected}
      >
        {this.preview}
      </Dropzone>
    );
  }

  get preview() {
    const { imageSrc, label, meta } = this.props;
    const { selectedImageFile } = this.state;

    if (!meta.error && selectedImageFile && selectedImageFile.preview) {
      return (
        <div className="o-container__flex-column o-container__flex--center">
          <span className="input-file-card__image-preview-container">
            <img src={selectedImageFile.preview} className="input-file-card__image-preview" />
          </span>
        </div>
      );
    }

    return [(
      <div key="inputFileCardTopPreview" className="input-file-card__top-preview o-container__flex-row o-container__flex-vertical--space-between">
        <span>{label}</span>
        <span className="input-file-card__icon-container">
          <img className="input-file-card__image-icon" src={imageSrc}/>
        </span>
      </div>
    ),  (
      <div key="inputFileCardBottomPreview" className="input-file-card__bottom-preview o-container__flex-row o-container__flex-vertical--space-between">
        <Button type="button" className="input-file-card__button button--outline-blue o-container__flex--full">
          <FormattedMessage id="form.upload.button"/>
        </Button>
        {this.footnote}
      </div>
    )];
  }

  get footnote() {
    const { meta } = this.props;
    if (meta.error) {
      return (
        <span className="input-file-card__footnote input-file-card__footnote--is-error">
          <FormattedMessage id={meta.error}/>
        </span>
      );
    }

    return (
      <span className="input-file-card__footnote">
        <FormattedMessage id="form.footnote.upload.limit.info" values={{ sizeInMb: MAX_IMAGE_FILE_SIZE_IN_MB }}/>
      </span>
    );
  }

  private onFileSelected(selectedFiles: InputFileImage[]) {
    const { input, meta } = this.props;
    meta.dispatch(change(meta.form, input.name, selectedFiles[0]));
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input/InputFileCard/InputFileCard.tsx